
export enum DimensionUomCd {
	FEET = 'Feet',
	INCHES = 'Inches',
	METERS = 'Meters'}
